import { useForm } from 'react-hook-form';
import { useRef } from 'react';

const EnhancedUseForm = (options) => {
  const methods = useForm(options);
  const inputRefs = useRef({});

  const originalRegister = methods.register;
  methods.register = (o) => {
    // console.log('EnhancedUseForm register', o);
    const registerFn = originalRegister(o);
    return (el) => {
      // console.log('EnhancedUseForm register el', el);
      if (el && !inputRefs.current[el.name]) {
        inputRefs.current[el.name] = el;
      }
      registerFn(el);
    };
  };

  methods.setFocus = (field) => {
    const inputRef = inputRefs.current[field];
    if (inputRef && inputRef.current) inputRef.current.focus();
  };

  methods.control.inputRefs = inputRefs;

  return methods;
};

export default EnhancedUseForm;
